import React, {Component,useState  } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { firestoreConnect } from  'react-redux-firebase'
import { compose } from 'redux'
import Box from '@mui/material/Box';


import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    TextField, 
    FormControl,
  Select,
  MenuItem
    
  } from '@mui/material';


  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


  import {baseAPIURL,downloadAPIURL} from "../../store/api/Access"

  import  { useEffect  } from 'react';
  import  axios  from 'axios'
  
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import Page404 from '../Page404';
import Loader from "../../components/other/Loader"



  
import CardMenu from "../../components/settings/CardMenu"


  const AccountProfileDetails = (props) => {
    const {user} = props
    const [values, setValues] = useState({notifications:{}});

    const [limit, setLimit] = React.useState(30);
    const [list, setList] = React.useState(null);
    const [{loading,loadingMore,error}, setStatus] = React.useState({loading:true});
  
    //const navigate = useNavigate();
    

    const HandleLoadMore = () => {

      const NewLimit = limit+30;
      setLimit(NewLimit)
      setStatus({loadingMore:true})
      firebase.auth().currentUser.getIdToken().then(function(idToken) {


          let data = JSON.stringify({
            "limit": NewLimit
          });

          let config = {
            method: 'post',
            //maxBodyLength: Infinity,
            url: baseAPIURL+'components/list',
            headers: { 
              'Authorization': idToken, 
              //'Content-Type': 'application/json'
            },
            data : data
          };
          
          axios.request(config).then(Result => {
                                  
              console.log(Result)
              if(Result.data.error)
              {
                  setStatus({error:true});
              }
              else if(Result.data.list)
              {
                  setList(Result.data.list)
                  setStatus({});
              }
              else
              {
                  setList([])
                  setStatus({error:true});
              }
            
        }).catch(err => {
              console.error("handleSubmit")
              console.error(err)
              setStatus({error:true});
        });
      });



    }



      const LoadData = () => {
          setStatus({loading:true});
          //setList(null)
          console.log("LoadData")
  
          console.log(firebase.auth().currentUser)
          firebase.auth().currentUser.getIdToken().then(function(idToken) {

            let data = JSON.stringify({
              "limit": limit
            });

            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: baseAPIURL+'components/list',
              headers: { 
                'Authorization': idToken, 
                'Content-Type': 'application/json'
              },
              data : data
            };
            
            axios.request(config).then(Result => {
                                    
                console.log(Result)
                if(Result.data.error)
                {
                    setStatus({error:true});
                }
                else if(Result.data.list)
                {
                    setList(Result.data.list)
                    setStatus({});
                }
                else
                {
                    setList([])
                    setStatus({error:true});
                }
              
          }).catch(err => {
                console.error("handleSubmit")
                console.error(err)
                setStatus({error:true});
          });
        });
          
      };
  
    useEffect(() => {
      LoadData();
    }, []);

    
    if(error)
    return(<Page404/>)


    return (
        <main >
      <form /*onSubmit={handleSubmit}*/ action="post"
        autoComplete="off"
        noValidate
      >

      <CardMenu 
            //subheader="The information can be edited"
            title="Components"
      >

        {loading ? <Loader color="green"/>:<Box>
  
        <Box sx={{mb:3}}>


          
        <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                            <TableCell>Name</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                {list &&  list.length>0 && list.map((row, index) => {
                  return (

                      <TableRow 
                          hover 
                          key={row.device_uuid} 
                          //onClick={(event) => handleClick(event, row.device_uuid)}

                      >
                          <TableCell>{row.name}</TableCell>
                      </TableRow>
                  )}
              )}

              

                        </TableBody>
                      </Table>
                    </TableContainer>


              </Box>

        
              <Button
                type="submit"
                color="primary"
                variant="contained"
              >
                Save details
              </Button>
            </Box>
        }
            
        </CardMenu>
        
    </form>
      </main>
    );
  };

  const mapStateToProps = (state) => {

    return {
        //user:firebase.auth().currentUser,
    }
}


export default compose(
    connect(mapStateToProps),
    /*firestoreConnect(props =>{
        return[
            { collection: 'Users', storeAs: 'Profile', doc:props.user.uid},
        ]
    })*/
) (AccountProfileDetails);